//Lenis START
let lenis;

function lenisStart() {
	lenis = new Lenis({
		duration: 2,
		smooth: true,
		smoothTouch: true,
		// Native wheel scroll site-wide (same as home page with iframe embeds).
		smoothWheel: false,
	});

	gsap.ticker.add((time) => {
		lenis.raf(time * 1000);
	});
	gsap.ticker.lagSmoothing(0);

	const refresh = () => {
		ScrollTrigger.clearScrollMemory();
		window.history.scrollRestoration = 'manual';
		ScrollTrigger.refresh(true);
	};
	refresh();
	window.addEventListener('resize', refresh);
}
//Lenis END

// Iframe embeds: no per-iframe Lenis stop/start (causes jitter with many embeds). pointer-events + mousedown to interact.
const IFRAME_EMBED_ZONE_SELECTOR = '.iframe-section, .quick-posts-section .image-side';

function deactivateAllIframeEmbeds() {
	document.querySelectorAll('.is-iframe-active').forEach(function(zone) {
		zone.classList.remove('is-iframe-active');
	});
}

function bindIframeEmbedGlobals() {
	if (window.__iframeEmbedGlobalsBound) {
		return;
	}
	window.__iframeEmbedGlobalsBound = true;

	// Delegated so Swiper loop clones (quick-posts) work without re-binding.
	document.addEventListener('mousedown', function(e) {
		var zone = e.target.closest(IFRAME_EMBED_ZONE_SELECTOR);
		if (zone && zone.querySelector('iframe')) {
			deactivateAllIframeEmbeds();
			zone.classList.add('is-iframe-active');
		}
	});

	document.addEventListener('click', function(e) {
		if (!e.target.closest(IFRAME_EMBED_ZONE_SELECTOR)) {
			deactivateAllIframeEmbeds();
		}
	});

	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape') {
			deactivateAllIframeEmbeds();
		}
	});
}

function initIframeEmbedScroll() {
	bindIframeEmbedGlobals();
}

// Smooth scroll START
$(function() {
	$('a[href*="#"]:not([href="#"])').on('click', function (e) {
		const pathnameMatch =
			location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '');
		const hostnameMatch = location.hostname === this.hostname;

		if (pathnameMatch && hostnameMatch) {
			// Same path + hash-only smooth scroll must not swallow links that also change the query
			// (e.g. /events/ → /events/?_category=party-conferences#newsPost) or the bar never updates and FacetWP state stays wrong.
			const linkSearch = this.search || '';
			const locSearch = window.location.search || '';
			if (linkSearch !== locSearch) {
				return;
			}

			const target = $(this.hash);
			if (target.length) {
				e.preventDefault();

				let headerTop = $('header[role=banner]').position().top;
 				let headerHeight = $('header[role=banner]').innerHeight();
				let offsetS = headerTop + headerHeight;

				if (typeof lenis !== 'undefined') {
					// Use Lenis’s scrollTo method for smooth scrolling
					lenis.scrollTo(target[0], {
						offset: -offsetS,
						duration: .2,
						easing: (t) => t, // optional linear easing
					});
				} else {
					// Fallback in case Lenis isn't ready
					$('html, body').animate({
						scrollTop: target.offset().top - offsetS,
					}, 200);
				}
			}
		}
	});
});
// Smooth scroll END

//Waypoints / scroll-reveal START (IntersectionObserver = fire when element enters viewport)
var waypointInViewObserver = null;
/** @type {Array<{destroy?: Function}>} */
var waypointLegacyInstances = [];

function waypoints() {
	if ('IntersectionObserver' in window) {
		if (waypointInViewObserver) {
			waypointInViewObserver.disconnect();
			waypointInViewObserver = null;
		}
		waypointInViewObserver = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					entry.target.classList.add('animate');
					waypointInViewObserver.unobserve(entry.target);
				}
			});
		}, {
			root: null,
			rootMargin: '0px',
			threshold: 0.01
		});
		document.querySelectorAll('.waypoint').forEach(function (el) {
			waypointInViewObserver.observe(el);
		});
		return;
	}

	if (typeof Waypoint === 'undefined') {
		return;
	}

	while (waypointLegacyInstances.length) {
		var prev = waypointLegacyInstances.pop();
		if (prev && typeof prev.destroy === 'function') {
			try {
				prev.destroy();
			} catch (err) {}
		}
	}

	$('.waypoint').each(function() {
		var thisOne = $(this);
		var el = thisOne.get(0);
		if (!el) {
			return;
		}

		waypointLegacyInstances.push(new Waypoint({
			element: el,
			handler: function(direction) {
				if(direction == 'down'){
					thisOne.addClass('animate');
				}
			},
			offset: function() {
				return Waypoint.viewportHeight() + 150;
			},
		}));

		waypointLegacyInstances.push(new Waypoint({
			element: el,
			handler: function(direction) {
				if(direction == 'up'){
					thisOne.removeClass('animate');
				}
			},
			offset: '100%'
		}));
	});
}
//Waypoints / scroll-reveal END

//Waypoint.refreshAll();

//Scroll Menu START
var body = document.body;
var triggerMenu = document.querySelector(".page-header .trigger-menu");
var nav = document.querySelector(".page-header nav");
var menu = document.querySelector(".page-header .menu");
var scrollUp = "scroll-up";
var scrollDown = "scroll-down";
let lastScroll = 0;

function handleScroll() {
	var currentScroll = window.pageYOffset;
	if (currentScroll < 50) {
		body.classList.remove(scrollUp);
		body.classList.remove(scrollDown);
		return;
	}

	if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
		// down
		body.classList.remove(scrollUp);
		body.classList.add(scrollDown);
	} else if (currentScroll < lastScroll && currentScroll < 50 && body.classList.contains(scrollDown)) {
		// up and at top
		body.classList.remove(scrollDown);
		body.classList.remove(scrollUp);
	} else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
		// up
		body.classList.remove(scrollDown);
		body.classList.add(scrollUp);
	}
	lastScroll = currentScroll;
}

window.addEventListener("scroll", handleScroll);

// Run once on load
document.addEventListener("DOMContentLoaded", handleScroll);
window.addEventListener("load", handleScroll);
//Scroll Menu END

//THIS PASSES THE THEME URL TO THE JS VIA FUNCTIONS.PHP
//console.log(myTheme);

//ACCORDION START
function accordion() {
	if ($('dl.accordion').length > 0) {
		
		$(document).on('click', 'dl.accordion dt', function(){
			var thisOne = $(this);
			thisOne.parent('dl.accordion').find('dt').next('dd').css('maxHeight', '0px');
			thisOne.parent('dl.accordion').find('dt').removeClass('open').find('i').find('span').text('open table');
			var ddH = thisOne.next('dd').find('.inner').outerHeight();
			thisOne.next('dd').css('maxHeight', ddH+'px');
			thisOne.addClass('open').find('i').find('span').text('close table');
	
			setTimeout(function(){
				waypoints();
			}, 500);
		});
	
		$(document).on('click', 'dl.accordion dt.open', function(){
			var thisOne = $(this);
			thisOne.parent('dl.accordion').find('dt').removeClass('open').find('i').find('span').text('open table');
			thisOne.parent('dl.accordion').find('dt').next('dd').css('maxHeight', '0px');
			thisOne.removeClass('open').find('i').find('span').text('open table');
			
			setTimeout(function(){
				waypoints();
			}, 500);
		});
	
		$(window).resize(function() {
			$('dl.accordion dt.open').each(function(){
				var thisOne = $(this);
				var ddH = thisOne.next('dd').find('.inner').outerHeight();
				thisOne.next('dd').css('maxHeight', ddH+'px');
			});
		});
	}
}
//ACCORDION END



//SEE IF A LINK OPENS A POPUP START
function popUp() {
	//checks to see if a links starts with #pop-
	$('a[href^="#pop-"], button[href^="#pop-"]').on('click', function(e){
		e.preventDefault();
		var thisOne = $(this);
		var thisPop = thisOne.attr('href');

		$('html').addClass('pop-open');
		$('.popup-con').removeClass('open');
		$('.popup-con'+thisPop).addClass('open');

		$('html').removeClass('menu-open');
		$('#burger').addClass('close').removeClass('open');
	});

	//closes all popups
	$('.popup-con .close').on('click', function(e){
		$('html').removeClass('pop-open');
		$('.popup-con').removeClass('open');
	});

	$('.pop-inner').click(function(e){
		e.stopPropagation()
	});
}
//SEE IF A LINK OPENS A POPUP END

//BURGER AND MENU START
function burgerAndMenu() {
	$('#burger').click(function(){
		if($(window).width() < 992){
			$(this).toggleClass('open').addClass('close');
			$('html').toggleClass('menu-open').removeClass('pop-open');
			$('.popup-con ').removeClass('open');
			//$(this).text($(this).hasClass('open') ? 'Close' : 'Menu');
		}
	});

	$('#filter').click(function(){
		if($(window).width() < 992){
			$(this).toggleClass('open').addClass('close');
			$('html').toggleClass('filter-open');
		}
	});

	$('li.menu-item-has-children').click(function(){
		if($(window).width() < 992){
			$(this).toggleClass('open');
		}
	});

	$('.main-menu li a').click(function(e){
		e.stopPropagation();

		if($(window).width() < 992){
			$('#burger').removeClass('open').addClass('close');
			$('html').toggleClass('menu-open').removeClass('pop-open');
			$('.popup-con ').removeClass('open');
		}
	});

	$('.main-menu li li').click(function(e){
		e.stopPropagation()
	});
}
//BURGER AND MENU END

//WP IMAGE CON FIX START
function wpImageFix() {
	$('p:has(img)').css('margin-bottom','0').addClass('p-img');

	// $('img.alignnone, img.alignright, img.alignleft, img.aligncenter ').each(function(){
	// 	var thisOne = $(this);
	// 	var thiswidth = thisOne.attr('width');

	// 	thisOne.css('width', thiswidth/10 + 'rem')
	// });
}
//WP IMAGE CON FIX END

//TABS START
function tabs() {
	$(document).on('click', '.tabs .tab, .tab-head', function() {
		var thisOne = $(this);
		thisOne.parents('.tab-container').find('.tab-content, .tabs .tab, .tab-head').removeClass('active');
		var activeTab = $(this).attr("rel");
		
		thisOne.parents('.tab-container').find('#'+activeTab).addClass('active');
		$(this).addClass('active');
		thisOne.parents('.tab-container').find('.tabs .tab[rel^='+activeTab+']').addClass('active');
		thisOne.parents('.tab-container').find('.tab-head[rel^='+activeTab+']').addClass('active');

		setTimeout(function(){
			waypoints();
		}, 500);
	});
}
//TABS END

//SIMPLED VIDEO PLAYER START
function simpleVideo() {
	$('.video-con .play-video').on('click', function(){
		var thisOne = $(this);
		var video = thisOne.parent('.video-con').addClass('playing').find('video')
		video.get(0).play()
	});
}
//SIMPLED VIDEO PLAYER END

//PAGE TRANSITION START
/**
 * True when href is the Events listing (same host) and the URL has more than bare /events/
 * — query string, hash, or a path segment after /events/ (e.g. Facet deep links).
 * Plain /events/ keeps the normal blue page transition.
 */
function pageTransitionHrefIsEventsListingWithExtras(href) {
	try {
		const u = new URL(href, window.location.href);
		if (u.hostname !== window.location.hostname) {
			return false;
		}
		const pathname = u.pathname || '/';
		const parts = pathname.replace(/\/+$/, '').split('/').filter(Boolean);
		const eventsIndex = parts.findIndex((part) => part.toLowerCase() === 'events');
		if (eventsIndex === -1) {
			return false;
		}
		const hasSubpathAfterEvents = eventsIndex < parts.length - 1;
		const hasQuery = Boolean(u.search && u.search.length > 1);
		const hasHash = Boolean(u.hash && u.hash.length > 1);
		return hasSubpathAfterEvents || hasQuery || hasHash;
	} catch (err) {
		return false;
	}
}

function pageTransitionHrefIsFileDownload(href) {
	try {
		const path = new URL(href, window.location.href).pathname || '';
		return /\.(pdf|xlsx|xls|csv|zip|docx?|pptx?|txt|svg)(\?.*)?$/i.test(path);
	} catch (err) {
		return /\.(pdf|xlsx|xls|csv|zip|docx?|pptx?|txt|svg)(\?.*)?$/i.test(href);
	}
}

function pageTransition() {
	let transitionTime = 200; //ms - may need to add more of a delay if the transition animation is more complex

	if (typeof wpRocket !== 'undefined' && wpRocket.is_on) {
		console.log('WP Rocket is on');
		transitionTime = 200; // ms - may need to add more of a delay if the transition animation is more complex
	}

	// Inline duration can override SCSS; skip only on Events URLs with extras (see body.events-listing-url-has-extras).
	if (!document.body.classList.contains('events-listing-url-has-extras')) {
		$('.loading-block').css('transition-duration', transitionTime + 'ms');
	}

	// Optional: add data-no-page-transition on any <a> to skip the full-screen blue .loading-block (native navigation).
	$('a:not([target="_blank"]):not([href^="#pop-"]):not([data-fancybox]):not([data-no-page-transition]):not([download])').each(function () {
		const $link = $(this);
		let href = $link.attr('href');

		// Skip empty/hash/javascript links
		if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;

		if ($link.closest('.wp-block-file').length || pageTransitionHrefIsFileDownload(href)) {
			return;
		}

		const hrefTargetsEventsWithExtras = pageTransitionHrefIsEventsListingWithExtras(href);

		// Hash links: never use the blue transition unless we need to treat /events/?…#… (handled via full href).
		if (href.indexOf('#') !== -1 && !hrefTargetsEventsWithExtras) {
			return;
		}

		if (href && href.startsWith('/#')) {
			href = href.replace(/^\/+/, "");
			if (href.length > 0) return;
		}

		const skipBlueOverlay = hrefTargetsEventsWithExtras;

		// Prefetch
		$link.on('mouseenter focus', function () {
			if (!$(`link[rel="prefetch"][href="${href}"]`).length) {
				$('<link rel="prefetch" href="' + href + '" />').appendTo('head');
			}
		});

		if (skipBlueOverlay) {
			return;
		}

		// Transition
		$link.on('click', function (e) {
			if (e.metaKey || e.ctrlKey || e.which === 2) return;

			e.preventDefault();
			$('html').addClass('internal-loaded');

			setTimeout(function () {
				window.location = href;
			}, transitionTime);
		});
	});

	window.addEventListener('pageshow', function () {
		document.documentElement.classList.remove('internal-loaded');
		if (typeof waypoints === 'function') waypoints();
	});

	$('html').removeClass('internal-loaded');
}
//PAGE TRANSITION END

//SIMPLED VIDEO PLAYER START
function nextLink() {
	$('.next-link').on('click', function(e){
		e.preventDefault();

		var thisOne = $(this);
		const target = thisOne.parents('section').next('section');
		
		let headerTop = $('header[role=banner]').position().top;
		let headerHeight = $('header[role=banner]').innerHeight();
		let offsetS = headerTop + headerHeight;

		if (typeof lenis !== 'undefined') {
			// Use Lenis’s scrollTo method for smooth scrolling
			lenis.scrollTo(target[0], {
				offset: -offsetS,
				duration: .2,
				easing: (t) => t, // optional linear easing
			});
		} else {
			// Fallback in case Lenis isn't ready
			$('html, body').animate({
				scrollTop: target.offset().top - offsetS,
			}, 200);
		}
	});
}
//SIMPLED VIDEO PLAYER END

$(window).ready(function() {
	pageTransition();
	wpImageFix();
	accordion();
	burgerAndMenu();
	popUp();
	//tabs();
	//simpleVideo();
	nextLink();

	// Animate above-the-fold waypoints immediately — don't wait for window.load
	// (window.load is blocked by image downloads, causing visible whitespace in the hero)
	$('section:first-child .waypoint, .info-top-section .waypoint').addClass('animate');
});

$(window).on('load', function(){
	$('html').addClass('loaded');

	$('.facetwp-type-pager').addClass('waypoint');

	gsap.registerPlugin(ScrollTrigger);

	lenisStart();
	initIframeEmbedScroll();

	setTimeout(function(){
		$(window).trigger('resize');

		setTimeout(function(){
			$(window).trigger('resize');
			waypoints();
		}, 0);
	}, 0);
	
	// const swiper = new Swiper('.-slide', {
	// 	loop: true,
	// 	spaceBetween: 0,
	// 	slidesPerView: 1,
	// 	preventInteractionOnTransition: true,
	// 	centerInsufficientSlides: true,
	// 	centeredSlides: false,
	// 	autoplay: {
	// 		delay: 3000,
	// 		disableOnInteraction: false,
	// 		pauseOnMouseEnter: true,
	// 	},
	// 	speed: 300,
	// 	navigation: {
	// 		nextEl: '.swiper-button-next',
	// 		prevEl: '.swiper-button-prev',
	// 	},
	// 	pagination: {
	// 		el: '.swiper-pagination',
	// 		type: 'bullets',
	// 		clickable: true,
	// 	},
	// 	scrollbar: {
	// 		el: '.swiper-scrollbar',
	// 		draggable: true,
	// 		hide: false,
	// 	},
	// 	breakpoints: {
	// 		992: {
	// 			centeredSlides: false,
	// 			spaceBetween: 0,
	// 			slidesPerView: 3,
	// 		},
	// 		1441: {
	// 			spaceBetween: 0,
	// 			slidesPerView: 4,
	// 		}
	// 	}
	// });

	const swiperTi = new Swiper('.title-slide', {
		loop: true,
		spaceBetween: 0,
		slidesPerView: 1,
		direction: 'vertical',
		preventInteractionOnTransition: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
		speed: 300,
	});

	const swiperL = new Swiper('.logo-slide', {
		loop: true,
		spaceBetween: 0,
		slidesPerView: 2.65,
		preventInteractionOnTransition: true,
		centerInsufficientSlides: true,
		centeredSlides: false,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
		speed: 300,
		breakpoints: {
			992: {
				centeredSlides: false,
				spaceBetween: 0,
				slidesPerView: 6,
			}
		}
	});

	document.querySelectorAll('.quick-slide').forEach(function(el) {
		new Swiper(el, {
			loop: true,
			spaceBetween: 0,
			slidesPerView: 1,
			preventInteractionOnTransition: true,
			centerInsufficientSlides: true,
			centeredSlides: false,
			navigation: {
				nextEl: el.querySelector('.swiper-button-next'),
				prevEl: el.querySelector('.swiper-button-prev'),
			},
			pagination: {
				el: el.querySelector('.swiper-pagination'),
				type: 'bullets',
				clickable: true,
			},
			autoplay: {
				delay: 6000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
			},
			breakpoints: {
				992: {
					centeredSlides: false,
					spaceBetween: 0,
					slidesPerView: 1.623,
				}
			}
		});
	});

	const swiperT = new Swiper('.trusted-slide', {
		loop: false,
		spaceBetween: 0,
		slidesPerView: 1,
		preventInteractionOnTransition: true,
		centerInsufficientSlides: true,
		centeredSlides: false,
		// autoplay: {
		// 	delay: 3000,
		// 	disableOnInteraction: false,
		// 	pauseOnMouseEnter: true,
		// },
		// speed: 300,
		breakpoints: {
			992: {
				centeredSlides: false,
				spaceBetween: 0,
				slidesPerView: 6,
			}
		}
	});

	// child and parent slides
	// swiperQ.controller.control = swiperQI;
	// swiperQI.controller.control = swiperQ;

	$('.swiper-wrapper').each(function(){
		$(this).parents('.swiper').css('overflow', 'visible');
		$(this).wrap('<div class="swiper-wrapper-con" style="overflow: hidden;"></div>');
	});

	$('.gform_button.button').append('<i><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.293 5.49998H8.586L5.9395 2.85348L6.6465 2.14648L10.5 5.99998L6.6465 9.85348L5.9395 9.14648L8.586 6.49998H1.293V5.49998Z" fill="#F5F4F0"/></svg></i>');

	jQuery(document).on('gform_page_loaded', function(event, form_id, current_page){
		$('.gform_button.button').append('<i><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.293 5.49998H8.586L5.9395 2.85348L6.6465 2.14648L10.5 5.99998L6.6465 9.85348L5.9395 9.14648L8.586 6.49998H1.293V5.49998Z" fill="#F5F4F0"/></svg></i>');
	});

	$(document).on("gform_confirmation_loaded", function (e, form_id) {
		setTimeout(function(){
			$(window).trigger('resize');
			waypoints();
			//ScrollTrigger.refresh();
		}, 0);
	});

	$('.bl2-item .inner').matchHeight({ property: 'min-height' });
	
	$('.bl3-item .inner').matchHeight({ property: 'min-height' });

	$('.bl5-item .icon').matchHeight({ property: 'min-height' });

	$('.bl5-item .inner').matchHeight({ property: 'min-height' });

	$('.bl6-item .inner').matchHeight({ property: 'min-height' });

	$('.r-item .inner').matchHeight({ property: 'min-height' });

	$('.ca-item .inner').matchHeight({ property: 'min-height' });

	$('.t-item .inner').matchHeight({ property: 'min-height' });

	document.addEventListener('facetwp-loaded', function(event){
		const url = new URL(window.location.href);
		const searchInput = document.querySelector('.facetwp-facet-s input.facetwp-search');

		if ( searchInput && searchInput.value === '' ) {
			// Ensure the URL always has _s= even if empty
			if (!url.searchParams.has('_s')) {
				url.searchParams.set('_s', '');
				window.history.replaceState({}, '', url.toString());
			}
		}

		setTimeout(function(){
			$(window).trigger('resize');
			waypoints();
			//ScrollTrigger.refresh();
			$('.bl2-item .inner').matchHeight({ property: 'min-height' });
	
			$('.bl3-item .inner').matchHeight({ property: 'min-height' });

			$('.r-item .inner').matchHeight({ property: 'min-height' });
		}, 0);
	});	

	// Topic dropdowns (research + podcast archives) synced with FacetWP radio facets
	function bindFacetTopicDropdown(cfg) {
		var $dropdown = $(cfg.dropdownId);
		if (!$dropdown.length) {
			return;
		}
		var $trigger  = $dropdown.find('.dropdown-trigger');
		var $panel    = $dropdown.find('.dropdown-panel');
		var $search   = $dropdown.find('.dropdown-search');
		var $options  = $dropdown.find('.dropdown-option');
		var $label    = $dropdown.find('.dropdown-label');

		$trigger.on('click', function(e) {
			e.stopPropagation();
			var open = $trigger.attr('aria-expanded') === 'true';
			$trigger.attr('aria-expanded', !open);
			$panel.toggleClass('open', !open);
			if (!open) { $search.val('').trigger('input').focus(); }
		});

		$panel.on('click', function(e) { e.stopPropagation(); });

		$search.on('input', function() {
			var q = $(this).val().toLowerCase();
			$options.each(function() {
				var dv = $(this).attr('data-value');
				if (dv === undefined || dv === null) {
					dv = '';
				}
				$(this).toggle($(this).text().toLowerCase().indexOf(q) > -1 || dv === '');
			});
		});

		$options.on('click', function() {
			var val   = $(this).attr('data-value');
			if (typeof val === 'undefined' || val === null) {
				val = '';
			}
			var label = $(this).text();
			$options.removeClass('active');
			$(this).addClass('active');
			$label.text(label);
			$trigger.attr('aria-expanded', 'false');
			$panel.removeClass('open');

			var $wrap = $(cfg.facetRadioWrap);
			if (!$wrap.length) {
				return;
			}
			var valStr = String(val);
			var $targetRadio = $wrap.find('.facetwp-radio').filter(function() {
				var d = $(this).attr('data-value');
				if (d === undefined || d === null) {
					d = '';
				}
				return String(d) === valStr;
			}).first();
			if ($targetRadio.length) {
				$targetRadio.trigger('click');
			} else {
				var $inp = $wrap.find('input[type="radio"]').filter(function() {
					return String(this.value) === valStr;
				}).first();
				if ($inp.length) {
					$inp.prop('checked', true).trigger('click');
				}
			}
		});

		document.addEventListener('facetwp-loaded', function() {
			if (typeof FWP === 'undefined' || !FWP.facets || !FWP.facets[cfg.facetKey]) {
				return;
			}
			var active = FWP.facets[cfg.facetKey];
			if (active && active.length > 0) {
				var $match = $dropdown.find('[data-value="' + CSS.escape(active[0]) + '"]');
				if ($match.length) {
					$options.removeClass('active');
					$match.addClass('active');
					$label.text($match.text());
				}
			} else {
				$options.removeClass('active');
				$dropdown.find('[data-value=""]').addClass('active');
				$label.text(cfg.allLabel);
			}
		});

		var urlParam = new URLSearchParams(window.location.search).get(cfg.urlParam);
		if (urlParam) {
			var $matchInit = $dropdown.find('[data-value="' + CSS.escape(urlParam) + '"]');
			if ($matchInit.length) {
				$options.removeClass('active');
				$matchInit.addClass('active');
				$label.text($matchInit.text());
			}
		}
	}

	if ($('#researchTypeDropdown, #podcastTypeDropdown').length) {
		$(document).on('click', function() {
			$('#researchTypeDropdown, #podcastTypeDropdown').each(function() {
				var $d = $(this);
				$d.find('.dropdown-trigger').attr('aria-expanded', 'false');
				$d.find('.dropdown-panel').removeClass('open');
			});
		});
	}

	bindFacetTopicDropdown({
		dropdownId: '#researchTypeDropdown',
		facetRadioWrap: '.facetwp-facet-research_type',
		facetKey: 'research_type',
		urlParam: '_research_type',
		allLabel: 'All topics'
	});

	bindFacetTopicDropdown({
		dropdownId: '#podcastTypeDropdown',
		facetRadioWrap: '.facetwp-facet-podcast_type',
		facetKey: 'podcast_type',
		urlParam: '_podcast_type',
		allLabel: 'All topics'
	});

	$('.video-section').fitVids();

	Fancybox.bind("[data-fancybox]", {
		Hash: false,
	});

	// //google map
	// (function( $ ) {

	// 	/**
	// 	 * initMap
	// 	 *
	// 	 * Renders a Google Map onto the selected jQuery element
	// 	 *
	// 	 * @date    22/10/19
	// 	 * @since   5.8.6
	// 	 *
	// 	 * @param   jQuery $el The jQuery element.
	// 	 * @return  object The map instance.
	// 	 */
	// 	function initMap( $el ) {
	
	// 		var stylers = [
	// 			{
	// 				"featureType": "all",
	// 				"elementType": "labels.text.fill",
	// 				"stylers": [
	// 					{
	// 						"saturation": 36
	// 					},
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 40
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "all",
	// 				"elementType": "labels.text.stroke",
	// 				"stylers": [
	// 					{
	// 						"visibility": "on"
	// 					},
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 16
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "all",
	// 				"elementType": "labels.icon",
	// 				"stylers": [
	// 					{
	// 						"visibility": "off"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative",
	// 				"elementType": "geometry.fill",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 20
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative",
	// 				"elementType": "geometry.stroke",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 17
	// 					},
	// 					{
	// 						"weight": 1.2
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative",
	// 				"elementType": "labels",
	// 				"stylers": [
	// 					{
	// 						"visibility": "off"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative.country",
	// 				"elementType": "all",
	// 				"stylers": [
	// 					{
	// 						"visibility": "simplified"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative.country",
	// 				"elementType": "geometry",
	// 				"stylers": [
	// 					{
	// 						"visibility": "simplified"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative.country",
	// 				"elementType": "labels.text",
	// 				"stylers": [
	// 					{
	// 						"visibility": "simplified"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative.province",
	// 				"elementType": "all",
	// 				"stylers": [
	// 					{
	// 						"visibility": "off"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative.locality",
	// 				"elementType": "all",
	// 				"stylers": [
	// 					{
	// 						"visibility": "simplified"
	// 					},
	// 					{
	// 						"saturation": "-100"
	// 					},
	// 					{
	// 						"lightness": "30"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative.neighborhood",
	// 				"elementType": "all",
	// 				"stylers": [
	// 					{
	// 						"visibility": "off"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "administrative.land_parcel",
	// 				"elementType": "all",
	// 				"stylers": [
	// 					{
	// 						"visibility": "off"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "landscape",
	// 				"elementType": "all",
	// 				"stylers": [
	// 					{
	// 						"visibility": "simplified"
	// 					},
	// 					{
	// 						"gamma": "0.00"
	// 					},
	// 					{
	// 						"lightness": "74"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "landscape",
	// 				"elementType": "geometry",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 20
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "landscape.man_made",
	// 				"elementType": "all",
	// 				"stylers": [
	// 					{
	// 						"lightness": "3"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "poi",
	// 				"elementType": "all",
	// 				"stylers": [
	// 					{
	// 						"visibility": "off"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "poi",
	// 				"elementType": "geometry",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 21
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "road",
	// 				"elementType": "geometry",
	// 				"stylers": [
	// 					{
	// 						"visibility": "simplified"
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "road.highway",
	// 				"elementType": "geometry.fill",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 17
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "road.highway",
	// 				"elementType": "geometry.stroke",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 29
	// 					},
	// 					{
	// 						"weight": 0.2
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "road.arterial",
	// 				"elementType": "geometry",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 18
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "road.local",
	// 				"elementType": "geometry",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 16
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "transit",
	// 				"elementType": "geometry",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 19
	// 					}
	// 				]
	// 			},
	// 			{
	// 				"featureType": "water",
	// 				"elementType": "geometry",
	// 				"stylers": [
	// 					{
	// 						"color": "#000000"
	// 					},
	// 					{
	// 						"lightness": 17
	// 					}
	// 				]
	// 			}
	// 		]
	
	// 		// Find marker elements within map.
	// 		var $markers = $el.find('.marker');
	
	// 		// Create gerenic map.
	// 		var mapArgs = {
	// 			//styles		: stylers,
	// 			mapTypeControl: false,
	// 			//draggable: false,
	// 			scaleControl: false,
	// 			scrollwheel: false,
	// 			fullscreenControl: false,
	// 			navigationControl: false,
	// 			streetViewControl: false,
	// 			zoom        : $el.data('zoom') || 16,
	// 			mapTypeId   : google.maps.MapTypeId.ROADMAP
	// 		};
	// 		var map = new google.maps.Map( $el[0], mapArgs );
	
	// 		// Add markers.
	// 		map.markers = [];
	// 		$markers.each(function(){
	// 			initMarker( $(this), map );
	// 		});
	
	// 		// Center map based on markers.
	// 		centerMap( map );
	
	// 		// Return map instance.
	// 		return map;
	// 	}
	
	// 	/**
	// 	 * initMarker
	// 	 *
	// 	 * Creates a marker for the given jQuery element and map.
	// 	 *
	// 	 * @date    22/10/19
	// 	 * @since   5.8.6
	// 	 *
	// 	 * @param   jQuery $el The jQuery element.
	// 	 * @param   object The map instance.
	// 	 * @return  object The marker instance.
	// 	 */
	// 	function initMarker( $marker, map ) {
	
	// 		// Get position from marker.
	// 		var lat = $marker.data('lat');
	// 		var lng = $marker.data('lng');
	// 		var latLng = {
	// 			lat: parseFloat( lat ),
	// 			lng: parseFloat( lng )
	// 		};
	
	// 		const icon = {
	// 			url: myTheme.theme_directory+"/assets/images/marker.svg", // url
	// 			scaledSize: new google.maps.Size(82, 103), // scaled size
	// 			origin: new google.maps.Point(0,0), // origin
	// 			anchor: new google.maps.Point(41, 103) // anchor
	// 		};
	
	// 		// Create marker instance.
	// 		var marker = new google.maps.Marker({
	// 			position : latLng,
	// 			//icon: icon,
	// 			map: map
	// 		});
	
	// 		// Append to reference for later use.
	// 		map.markers.push( marker );
	
	// 		// If marker contains HTML, add it to an infoWindow.
	// 		if( $marker.html() ){
	
	// 			// Create info window.
	// 			var infowindow = new google.maps.InfoWindow({
	// 				content: $marker.html()
	// 			});
	
	// 			// Show info window when marker is clicked.
	// 			google.maps.event.addListener(marker, 'click', function() {
	// 				infowindow.open( map, marker );
	// 			});
	// 		}
	// 	}
	
	// 	/**
	// 	 * centerMap
	// 	 *
	// 	 * Centers the map showing all markers in view.
	// 	 *
	// 	 * @date    22/10/19
	// 	 * @since   5.8.6
	// 	 *
	// 	 * @param   object The map instance.
	// 	 * @return  void
	// 	 */
	// 	function centerMap( map ) {
	
	// 		// Create map boundaries from all map markers.
	// 		var bounds = new google.maps.LatLngBounds();
	// 		map.markers.forEach(function( marker ){
	// 			bounds.extend({
	// 				lat: marker.position.lat(),
	// 				lng: marker.position.lng()
	// 			});
	// 		});
	
	// 		// Case: Single marker.
	// 		if( map.markers.length == 1 ){
	// 			map.setCenter( bounds.getCenter() );
	
	// 		// Case: Multiple markers.
	// 		} else{
	// 			map.fitBounds( bounds );
	// 		}
	// 	}
	
	// 	$('.acf-map').each(function(){
	// 		var map = initMap( $(this) );
	// 	});

	// })(jQuery);

// Author page research AJAX pagination
const researchSection = document.getElementById('author-research');
if (researchSection) {
	history.replaceState({ url: window.location.href }, '', window.location.href);

	document.addEventListener('click', function(e) {
		const link = e.target.closest('#author-research .pagination a');
		if (!link) return;
		e.preventDefault();
		e.stopImmediatePropagation();
		fetchResearchPage(link.href, true);
	}, true);

	window.addEventListener('popstate', function(e) {
		if (e.state && e.state.url) {
			fetchResearchPage(e.state.url, false);
		}
	});

	function fetchResearchPage(url, push) {
		const content = document.getElementById('author-research-content');
		content.style.opacity = '0.5';
		content.style.pointerEvents = 'none';

		const headerOffset = $('header[role=banner]').position().top + $('header[role=banner]').innerHeight();
		if (typeof lenis !== 'undefined') {
			lenis.scrollTo(researchSection, { offset: -headerOffset, duration: 0.6 });
		} else {
			researchSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}

		fetch(url)
			.then(function(res) { return res.text(); })
			.then(function(html) {
				const doc = new DOMParser().parseFromString(html, 'text/html');
				const newContent = doc.getElementById('author-research-content');
				if (newContent) {
					content.innerHTML = newContent.innerHTML;
				}
				content.querySelectorAll('.waypoint').forEach(function(el) {
					el.classList.add('animate');
				});
				content.style.opacity = '1';
				content.style.pointerEvents = '';
				if (push) {
					history.pushState({ url: url }, '', url);
				}
			})
			.catch(function() {
				window.location.href = url;
			});
	}
}

// Events feed: scroll to #events-feed when ?_category= is present in the URL
$(function() {
	const params = new URLSearchParams(window.location.search);
	const feed = document.getElementById('events-feed');
	if (params.has('_category') && feed) {
		document.addEventListener('facetwp-loaded', function() {
			const headerOffset = $('header[role=banner]').position().top + ($('header[role=banner]').innerHeight() || 0);
			if (typeof lenis !== 'undefined') {
				lenis.scrollTo(feed, { offset: -headerOffset, duration: 0.6 });
			} else {
				$('html, body').animate({ scrollTop: $(feed).offset().top - headerOffset }, 400);
			}
		}, { once: true });
	}
});

});